import { Dataset } from '../../types/types';
import { ParsedDatasetControlData } from './parseDatasetControlData';

export type DatasetControlDataStatus = 'none' | 'pending' | 'invalid' | 'valid';

// Status of the dataset control data param for the currently opened dataset.
export const getDatasetControlDataStatus = (
  parsed: ParsedDatasetControlData,
  routeDatasetId: string | undefined,
  datasetId: string | undefined,
  dataset: Dataset | undefined
): DatasetControlDataStatus => {
  if (!parsed) {
    return 'none';
  }
  // Context datasetId lags the route by one effect (withDatasetScope) and the
  // dataset definition arrives later still — never judge the data (or toast)
  // mid-transition.
  if (
    !datasetId ||
    routeDatasetId !== datasetId ||
    !dataset ||
    dataset.datasetId !== datasetId
  ) {
    return 'pending';
  }
  // No content validation — the data is opaque to the frontend; apiMethod
  // JSONata expressions on the backend definitions own its interpretation.
  // Only an unparseable/non-object payload is rejected.
  if ('malformed' in parsed) {
    return 'invalid';
  }
  return 'valid';
};
